module.exports = __webpack_public_path__ + "static/media/Start Screeen-05.ed3e8498.webp";